module.exports = __webpack_public_path__ + "static/showreel2022-7f4cf73cb69cace7214f29814d4b88af.jpeg";